export const MAX_IMAGE_FILE_SIZE_BYTES = 10 * 1024 * 1024
export const MAX_DOCUMENT_FILE_SIZE_BYTES = 50 * 1024 * 1024
